import memoizeOne from 'memoize-one';

import { cfetch } from '@confluence/network';

export type Trait = {
	name: string;
	value: string;
};

type UserTraitsState = {
	attributes: Trait[] | null;
};

const fetchPersonalizationSiteUserTraits = async (cloudId: string): Promise<UserTraitsState> => {
	const response = await cfetch(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`);
	return response.json();
};

const callSiteTraits = async (cloudId: string): Promise<Trait[]> => {
	if (!cloudId) {
		return [];
	}

	const siteUserTraitsData = await fetchPersonalizationSiteUserTraits(cloudId);
	if (!siteUserTraitsData || !siteUserTraitsData.attributes) {
		return [];
	}

	return siteUserTraitsData.attributes;
};

export const getSiteTraits = memoizeOne(callSiteTraits);
